import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';

export type ShouldPreloadBylineConnectionsSsrStateParams = {
	isReactSsr: boolean;
	isLoggedIn: boolean;
	cloudId?: string;
	contentId?: string;
};

// Gate for warming the Teamwork Graph connections byline SSR state. Keeps the SSR-only
// conditions and the experiment check in one unit-tested place.
export const shouldPreloadBylineConnectionsSsrState = ({
	isReactSsr,
	isLoggedIn,
	cloudId,
	contentId,
}: ShouldPreloadBylineConnectionsSsrStateParams): boolean =>
	isReactSsr &&
	isLoggedIn &&
	Boolean(cloudId) &&
	Boolean(contentId) &&
	// The existing byline UI owns exposure for this experiment.
	// eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
	UNSAFE_expValEqualsNoExposure(
		'confluence_1p_and_3p_connection_byline_experiment',
		'isEnabled',
		true,
	);
